<div class="notification notification-{{ severity | lowercase }}">
    {{ text }}

    <button *ngIf="canClose" i18n class="button-game" (click)="closeClicked.emit()">Clear</button>
</div>
